import { FieldTypes } from 'drapcode-constant';
import { findParentCollection } from '../collectionTraits/utils';
import { fieldTraitTextContentOptions } from '../dataGroup/traitsApi';
import { getCollectionFields } from '../pluginComponentApi';
import { stripeConnectType } from './consts';

export default async function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const {
    pfx,
    classPfx,
    projectId,
    collections,
    version,
    installedPlugins,
    bindCollectionOptions,
  } = opts;
  console.log('🚀 ~ components: stripe-connect ~ opts:', opts);

  const multiTenantPlugin =
    installedPlugins && installedPlugins.find((plugin) => plugin.code === 'MULTI_TENANT_SAAS');
  const { setting: multiTenantSetting } = multiTenantPlugin || '';
  const { multiTenantCollection, subTenantCollection, userSettingsCollection } =
    multiTenantSetting || '';

  domc.addType(stripeConnectType, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-cart-check"></i>',
          droppable: ':not(form)',
          draggable: ':not(form)',
          collectionName: '',
          projectId: projectId,
          resizable: true,
          traits: [
            ...defaultModel.prototype.defaults.traits,
            {
              type: 'content',
              label: 'Text',
            },
            {
              type: 'checkbox',
              label: 'Open in new tab',
              name: 'data-newtab',
            },
          ],
        },
        async init() {
          const collectionName = findParentCollection(this, opts);
          if (collectionName) {
            const collectionResponse = await getCollectionFields(collectionName, collections);
            const userCollectionResponse = await getCollectionFields('user', collections);
            const dataItemCustomerFrom = this.get('data-item-customer-from');
            if (!dataItemCustomerFrom) {
              this.set('data-item-customer-from', '');
            }
            const options = [
              { value: '', name: '- Select One -' },
              { value: 'PARENT_COLLECTION', name: 'Parent Collection' },
            ];
            if (
              bindCollectionOptions &&
              bindCollectionOptions.collection &&
              bindCollectionOptions.collection.options
            ) {
              options.push({ value: 'PAGE_COLLECTION', name: 'Page Collection' });
            }
            options.push({ value: 'CURRENT_USER_FIELD', name: 'Current Logged In User' });
            if (multiTenantCollection) {
              const multiTenantCollectionObj = collections.find(
                (collection) => collection.uuid === multiTenantCollection,
              );
              const multiTenantCollectionName = multiTenantCollectionObj
                ? multiTenantCollectionObj.collectionTitle
                : 'Tenant';
              options.push({
                value: 'CURRENT_TENANT_FIELD',
                name: `Current Logged In ${multiTenantCollectionName}`,
              });
            }
            if (userSettingsCollection) {
              const userSettingsCollectionObj = collections.find(
                (collection) => collection.uuid === userSettingsCollection,
              );
              const userSettingsCollectionName = userSettingsCollectionObj
                ? userSettingsCollectionObj.collectionTitle
                : 'User Settings';
              options.push({
                value: 'CURRENT_USER_SETTINGS_FIELD',
                name: `Current Logged In ${userSettingsCollectionName}`,
              });
            }
            if (subTenantCollection) {
              const subTenantCollectionObj = collections.find(
                (collection) => collection.uuid === subTenantCollection,
              );
              const subTenantCollectionName = subTenantCollectionObj
                ? subTenantCollectionObj.collectionTitle
                : 'Sub Tenant';
              options.push({
                value: 'CURRENT_SUB_TENANT_FIELD',
                name: `Current Logged In ${subTenantCollectionName}`,
              });
            }
            options.push({ value: 'BROWSER_SESSION_STORAGE', name: 'Browser Session Storage' });
            options.push({ value: 'BROWSER_LOCAL_STORAGE', name: 'Browser Local Storage' });
            options.push({ value: 'BROWSER_COOKIES', name: 'Browser Cookies' });

            if (collectionResponse || userCollectionResponse) {
              const textTraitsOptions = await fieldTraitTextContentOptions(
                collectionResponse,
                collections,
              );
              const userTextTraitsOptions = await fieldTraitTextContentOptions(
                userCollectionResponse,
                collections,
              );
              if (textTraitsOptions) {
                this.addTrait({
                  label: 'Name Field',
                  name: 'data-item-name',
                  title: 'name',
                  type: 'data-stripe-trait',
                  options: textTraitsOptions,
                });
                this.addTrait({
                  label: 'Description Field',
                  name: 'data-item-description',
                  title: 'description',
                  type: 'data-stripe-trait',
                  options: textTraitsOptions,
                });
                this.addTrait({
                  label: 'Price Field',
                  name: 'data-item-price',
                  title: 'price',
                  type: 'data-stripe-trait',
                  options: textTraitsOptions,
                });
                this.addTrait(
                  {
                    type: 'select',
                    label: 'Get Customer From',
                    name: 'data-item-customer-from',
                    title: 'customer-from',
                    options: [...options],
                    value: dataItemCustomerFrom,
                    changeProp: 1,
                  },
                  { at: this.getTraitIndex('data-item-price') + 1 },
                );
              }

              const collectionReferenceFields =
                collectionResponse.fields && collectionResponse.fields.length > 0
                  ? collectionResponse.fields.filter((crd) => crd.type === FieldTypes.reference.id)
                  : [];
              this.setAttributes({
                selectedCollectionData: JSON.stringify(collectionReferenceFields),
                onclick: 'stripeConnectCheckout(event)',
              });
            }
          }
          this.on('change:data-item-customer-from', this.handleCustomerFromChange);
          const dataItemCustomerFrom = this.get('data-item-customer-from');
          if (dataItemCustomerFrom) {
            await this.handleCustomerFromChange();
          }
        },
        async handleCustomerFromChange() {
          const dataItemCustomerFrom = this.get('data-item-customer-from');
          const attrs = this.getAttributes();
          const previousCustomerFrom = attrs['data-item-customer-from-prev'];
          const hasSourceChanged =
            previousCustomerFrom && previousCustomerFrom !== dataItemCustomerFrom;
          attrs['data-item-customer-from'] = dataItemCustomerFrom;
          this.addAttributes(attrs);

          const existingTrait = this.getTrait('data-item-customer-field');
          if (existingTrait) {
            this.removeTrait('data-item-customer-field');
          }
          if (hasSourceChanged) {
            this.set('data-item-customer-field', '');
            const updatedAttrs = this.getAttributes();
            delete updatedAttrs['data-item-customer-field'];
            this.addAttributes(updatedAttrs);
          }

          if (!dataItemCustomerFrom) {
            const updatedAttrs = this.getAttributes();

            delete updatedAttrs['data-item-customer-from'];
            delete updatedAttrs['data-item-customer-field'];
            delete updatedAttrs['data-item-customer-from-prev'];

            this.addAttributes(updatedAttrs);

            return;
          }

          const existingValue = hasSourceChanged
            ? ''
            : this.get('data-item-customer-field') || attrs['data-item-customer-field'] || '';

          const addCustomerTrait = (trait) => {
            const isTextTrait = trait.type === 'text';
            let traitValue = '';
            if (!hasSourceChanged) {
              traitValue =
                this.get('data-item-customer-field') || attrs['data-item-customer-field'] || '';
            }

            this.addTrait({
              ...trait,
              value: traitValue,
              changeProp: 1,
            });
            if (isTextTrait) {
              this.off('change:data-item-customer-field', this.__customerFieldListener);
              this.__customerFieldListener = () => {
                const latestValue = this.get('data-item-customer-field') || '';

                const latestAttrs = this.getAttributes();
                if (latestValue) {
                  latestAttrs['data-item-customer-field'] = latestValue;
                } else {
                  delete latestAttrs['data-item-customer-field'];
                }
                this.addAttributes(latestAttrs);
              };
              this.on('change:data-item-customer-field', this.__customerFieldListener);
            }
            setTimeout(() => {
              const latestAttrs = this.getAttributes();
              if (traitValue) {
                latestAttrs['data-item-customer-field'] = traitValue;
              } else {
                delete latestAttrs['data-item-customer-field'];
              }
              latestAttrs['data-item-customer-from-prev'] = dataItemCustomerFrom;
              this.addAttributes(latestAttrs);
            }, 0);
          };

          switch (dataItemCustomerFrom) {
            case 'CURRENT_USER_FIELD':
              if (
                bindCollectionOptions &&
                bindCollectionOptions.session &&
                bindCollectionOptions.session.options
              ) {
                addCustomerTrait({
                  label: 'Customer Field',
                  name: 'data-item-customer-field',
                  title: 'customer',
                  type: 'data-stripe-trait',
                  options: bindCollectionOptions.session.options,
                });
              }
              break;

            case 'CURRENT_TENANT_FIELD':
              if (
                bindCollectionOptions &&
                bindCollectionOptions.sessionTenant &&
                bindCollectionOptions.sessionTenant.options
              ) {
                addCustomerTrait({
                  label: 'Customer Field',
                  name: 'data-item-customer-field',
                  title: 'customer',
                  type: 'data-stripe-trait',
                  options: bindCollectionOptions.sessionTenant.options,
                });
              }
              break;

            case 'CURRENT_USER_SETTINGS_FIELD':
              if (
                bindCollectionOptions &&
                bindCollectionOptions.sessionUserSettings &&
                bindCollectionOptions.sessionUserSettings.options
              ) {
                addCustomerTrait({
                  label: 'Customer Field',
                  name: 'data-item-customer-field',
                  title: 'customer',
                  type: 'data-stripe-trait',
                  options: bindCollectionOptions.sessionUserSettings.options,
                });
              }
              break;

            case 'CURRENT_SUB_TENANT_FIELD':
              if (
                bindCollectionOptions &&
                bindCollectionOptions.sessionSubTenant &&
                bindCollectionOptions.sessionSubTenant.options
              ) {
                addCustomerTrait({
                  label: 'Customer Field',
                  name: 'data-item-customer-field',
                  title: 'customer',
                  type: 'data-stripe-trait',
                  options: bindCollectionOptions.sessionSubTenant.options,
                });
              }
              break;

            case 'BROWSER_SESSION_STORAGE':
              addCustomerTrait({
                label: 'Storage Key',
                name: 'data-item-customer-field',
                title: 'customer',
                type: 'text',
                placeholder: 'Enter session storage key',
              });
              break;

            case 'BROWSER_LOCAL_STORAGE':
              addCustomerTrait({
                label: 'Storage Key',
                name: 'data-item-customer-field',
                title: 'customer',
                type: 'text',
                placeholder: 'Enter local storage key',
              });
              break;

            case 'BROWSER_COOKIES':
              addCustomerTrait({
                label: 'Storage Key',
                name: 'data-item-customer-field',
                title: 'customer',
                type: 'text',
                placeholder: 'Enter cookies key',
              });
              break;

            case 'PARENT_COLLECTION': {
              const collectionName = findParentCollection(this, opts);

              if (collectionName) {
                const collectionResponse = await getCollectionFields(collectionName, collections);

                if (collectionResponse) {
                  const textTraitsOptions = await fieldTraitTextContentOptions(
                    collectionResponse,
                    collections,
                  );

                  if (textTraitsOptions) {
                    addCustomerTrait({
                      label: 'Customer Field',
                      name: 'data-item-customer-field',
                      title: 'customer',
                      type: 'data-stripe-trait',
                      options: textTraitsOptions,
                    });
                  }
                }
              }

              break;
            }

            case 'PAGE_COLLECTION':
              if (
                bindCollectionOptions &&
                bindCollectionOptions.collection &&
                bindCollectionOptions.collection.options
              ) {
                addCustomerTrait({
                  label: 'Customer Field',
                  name: 'data-item-customer-field',
                  title: 'customer',
                  type: 'data-stripe-trait',
                  options: bindCollectionOptions.collection.options,
                });
              }
              break;

            default:
              break;
          }

          const finalAttrs = this.getAttributes();

          finalAttrs['data-item-customer-from-prev'] = dataItemCustomerFrom;

          this.addAttributes(finalAttrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === stripeConnectType) {
            return {
              type: stripeConnectType,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(this.model, 'change:content', this.updateContent);
        this.listenTo(model, 'change:data-item-name', this.updateScript);
        this.listenTo(model, 'change:data-item-description', this.updateScript);
        this.listenTo(model, 'change:data-item-price', this.updateScript);
        this.listenTo(model, 'change:data-item-customer', this.updateScript);
      },
      updateContent() {
        if (this.model.get('content')) {
          this.el.innerHTML = this.model.get('content');
        }
      },
    }),
  });
}
